/* eslint-disable jsx-a11y/no-distracting-elements */
import React from "react";
import style from "./socialWorks.module.css";
import { GiFlowerStar } from "react-icons/gi";
import axios from "axios";
import { useEffect, useState } from "react";
import {
  API_AUTH_PASSWORD,
  API_AUTH_USERNAME,
  API_BASE_URL,
  ADMIN_ID,
} from "../../Constant/Global";
import AOS from "aos";
import "aos/dist/aos.css";
import Loader from "../../components/loader/Loader";

const SocialWorks = () => {
  const [socialWorkData, setSocialWorkData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    AOS.init({
      offset: 200,
    });
  }, []);

  // social work api

  const handleSocialWorkData = async () => {
    try {
      const finalData = { admin_id: ADMIN_ID };
      // console.log("finalData", finalData);
      const response = await axios.post(
        API_BASE_URL + "web/social_work",
        finalData,
        {
          auth: {
            username: API_AUTH_USERNAME,
            password: API_AUTH_PASSWORD,
          },
        }
      );
      // console.log("social work response", response.data.data);
      setIsLoading(false);
      setSocialWorkData(response.data.data);
    } catch (error) {
      console.log(error.response);
    }
  };

  useEffect(() => {
    handleSocialWorkData();
  }, []);

  return (
    <>
      {isLoading ? (
        <Loader />
      ) : (
        <div
          className={`container-fluid ps-0 pe-0 ${style.scheme_container_fluid}`}
        >
          {/* Schemes row */}
          <div className={`row ${style.social_works_row}`}>
            <header className={`${style.schemes_top_common_title_sec}`}>
              <span className={`${style.schemes_c_span_title}`}>
                SOCIAL WORK
              </span>
              <h5 className={`${style.schemes_c_heading_title}`}>समाजकार्य</h5>
            </header>

            {/* first div */}
            {socialWorkData?.social_work?.map((ele, index) => {
              return index % 2 === 0 ? (
                <React.Fragment key={ele.id}>
                  <div
                    data-aos="fade-right"
                    data-aos-duration="1500"
                    className="col-lg-4 mb-4"
                    id={`${style.order_one}`}
                  >
                    <div className={`${style.social_work_info_sec}`}>
                      <h5 className={`${style.social_work_info_main_title}`}>
                        <span>
                          <GiFlowerStar />
                        </span>{" "}
                        {ele.title}
                      </h5>
                      <p className={`${style.social_work_info_para}`}>
                        {ele.sub_title}
                      </p>
                      <span
                        className={`${style.social_work_info_span}`}
                        dangerouslySetInnerHTML={{
                          __html: ele.description,
                        }}
                      />
                    </div>
                  </div>
                  <div
                    data-aos="fade-left"
                    data-aos-duration="1500"
                    className="col-lg-8 mb-4"
                    id={`${style.order_two}`}
                  >
                    <div className={`${style.social_work_img_sec}`}>
                      <div
                        className={`${style.social_small_img_grp}`}
                        style={{
                          backgroundImage: `url('${ele.image1}')`,
                          backgroundSize: "cover",
                          backgroundPosition: "inherit",
                          backgroundRepeat: "no-repeat",
                        }}
                      ></div>
                      <div
                        className={`${style.social_small_img_grp}`}
                        style={{
                          backgroundImage: `url('${ele.image2}')`,
                          backgroundSize: "cover",
                          backgroundPosition: "inherit",
                          backgroundRepeat: "no-repeat",
                        }}
                      ></div>
                      <div
                        className={`${style.social_small_img_grp}`}
                        style={{
                          backgroundImage: `url('${ele.image3}')`,
                          backgroundSize: "cover",
                          backgroundPosition: "inherit",
                          backgroundRepeat: "no-repeat",
                        }}
                      ></div>
                    </div>
                    <div className={`${style.social_work_img_sec}`}>
                      <div
                        className={`${style.social_big_img_grp}`}
                        style={{
                          backgroundImage: `url('${ele.image4}')`,
                          backgroundSize: "cover",
                          backgroundPosition: "inherit",
                          backgroundRepeat: "no-repeat",
                        }}
                      ></div>
                      <div
                        className={`${style.social_big_img_grp}`}
                        style={{
                          backgroundImage: `url('${ele.image5}')`,
                          backgroundSize: "cover",
                          backgroundPosition: "inherit",
                          backgroundRepeat: "no-repeat",
                        }}
                      ></div>
                      <div className={`${style.social_video_grp}`}>
                        <iframe
                          style={{ height: "100%", width: "100%" }}
                          // width="500"
                          // src="https://www.youtube.com/embed/E_gjxdSfGB4?si=2utSOEAWrICF_787"
                          src={ele.youtube_url}
                          title="workers working"
                          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                          allowFullScreen
                        ></iframe>
                      </div>
                    </div>
                  </div>
                </React.Fragment>
              ) : (
                <React.Fragment key={ele.id}>
                  <div
                    data-aos="fade-right"
                    data-aos-duration="1500"
                    className="col-lg-8"
                    id={`${style.order_four}`}
                  >
                    <div className={`${style.social_work_img_sec}`}>
                      <div
                        className={`${style.social_small_img_grp}`}
                        style={{
                          backgroundImage: `url('${ele.image1}')`,
                          backgroundSize: "cover",
                          backgroundPosition: "inherit",
                          backgroundRepeat: "no-repeat",
                          // height: "200px",
                          // width: "100%",
                        }}
                      >
                        {/* <img
                    src={ele.image1}
                    alt="social-img"
                    className="img-fluid"
                  /> */}
                      </div>
                      <div
                        className={`${style.social_small_img_grp}`}
                        style={{
                          backgroundImage: `url('${ele.image2}')`,
                          backgroundSize: "cover",
                          backgroundPosition: "inherit",
                          backgroundRepeat: "no-repeat",
                          // height: "200px",
                          // width: "100%",
                        }}
                      >
                        {/* <img
                    src={ele.image2}
                    alt="social-img"
                    className="img-fluid"
                  /> */}
                      </div>
                      <div
                        className={`${style.social_small_img_grp}`}
                        style={{
                          backgroundImage: `url('${ele.image3}')`,
                          backgroundSize: "cover",
                          backgroundPosition: "inherit",
                          backgroundRepeat: "no-repeat",
                          // height: "200px",
                          // width: "100%",
                        }}
                      >
                        {/* <img
                    src={ele.image3}
                    alt="social-img"
                    className="img-fluid"
                  /> */}
                      </div>
                    </div>
                    <div className={`${style.social_work_img_sec}`}>
                      <div
                        className={`${style.social_big_img_grp}`}
                        style={{
                          backgroundImage: `url('${ele.image4}')`,
                          backgroundSize: "cover",
                          backgroundPosition: "inherit",
                          backgroundRepeat: "no-repeat",
                          // height: "200px",
                          // width: "100%",
                        }}
                      >
                        {/* <img
                    src={ele.image4}
                    alt="social-img"
                    className="img-fluid"
                  /> */}
                      </div>
                      <div
                        className={`${style.social_big_img_grp}`}
                        style={{
                          backgroundImage: `url('${ele.image5}')`,
                          backgroundSize: "cover",
                          backgroundPosition: "inherit",
                          backgroundRepeat: "no-repeat",
                          // height: "200px",
                          // width: "100%",
                        }}
                      >
                        {/* <img
                    src={ele.image5}
                    alt="social-img"
                    className="img-fluid"
                  /> */}
                      </div>
                      <div className={`${style.social_video_grp}`}>
                        <iframe
                          style={{ height: "100%", width: "100%" }}
                          // width="500"
                          // src="https://www.youtube.com/embed/E_gjxdSfGB4?si=2utSOEAWrICF_787"
                          src={ele.youtube_url}
                          title="workers working"
                          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                          allowFullScreen
                        ></iframe>
                      </div>
                    </div>
                  </div>
                  <div
                    data-aos="fade-left"
                    data-aos-duration="1500"
                    className="col-lg-4"
                    id={`${style.order_three}`}
                  >
                    <div className={`${style.social_work_info_sec}`}>
                      <h5 className={`${style.social_work_info_main_title}`}>
                        <span>
                          <GiFlowerStar />
                        </span>{" "}
                        {ele.title}
                      </h5>
                      <p className={`${style.social_work_info_para}`}>
                        {ele.sub_title}
                      </p>
                      <span
                        className={`${style.social_work_info_span}`}
                        dangerouslySetInnerHTML={{
                          __html: ele.description,
                        }}
                      />
                    </div>
                  </div>
                </React.Fragment>
              );
            })}
          </div>

          {/* client logos */}
          <div className={`row ${style.client_logo_row}`}>
            <div className="col-lg-12 ps-0 pe-0">
              <ul className={`${style.client_logo_ul_list}`}>
                {socialWorkData?.co_partner?.map((ele) => {
                  return (
                    <li key={ele.id} className={`${style.client_logo_list}`}>
                      <img
                        src={ele.image}
                        loading="lazy"
                        alt="client"
                        className="img-fluid"
                      />
                    </li>
                  );
                })}
              </ul>
            </div>
          </div>
          {/* award row */}
          <div className={`row ${style.social_award_row}`}>
            <header className={`${style.schemes_top_common_title_sec}`}>
              <span className={`${style.schemes_c_span_title}`}>
                SOCIAL WORK
              </span>
              <h5 className={`${style.schemes_c_heading_title}`}>
                ग्रामपंचायत पुरस्कार
              </h5>
            </header>
            {socialWorkData?.gram_panchayat_award?.map((ele) => {
              return (
                <div
                  key={ele.id}
                  data-aos="flip-right"
                  data-aos-duration="1500"
                  className={`col-lg-2 ${style.social_award_same_col}`}
                >
                  <div className={`${style.award_img_same_sec}`}>
                    <img
                      src={ele.image}
                      loading="lazy"
                      alt="award"
                      className="img-fluid"
                    />
                    <p className={`${style.award_img_text}`}>{ele.title}</p>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      )}
    </>
  );
};

export default SocialWorks;
